import React from 'react';
import PropTypes from 'prop-types';
import phoneFormatter from 'phone-formatter';

const PhoneNumber = ({phoneNumber}) => {
    const phone = phoneFormatter.format(phoneNumber,'NNN.NNN.NNNN');
    return (
        <div>
            <a href={`tel:${phone}`}>{phone}</a>
            
        </div>
    );
};


PhoneNumber.propTypes = {
    phoneNumber: PropTypes.string.isRequired,
};

export default PhoneNumber;